import moment from "moment";
import {
    APPLY_FILTER_SMR_KEYWORD,
    RESET_CURRENT_SMR_KEYWORD_FILTER,
    UPDATE_CUSTOM_QUERY_SMR_KEYWORD,
    UPDATE_FILTER_REFINE_SORT_SMR_KEYWORD,
    FETCH_SMR_KEYWORD_LISTS,
    RELOAD_PAGE,
} from "../actions/keywordSyncedPostsAction";
import { isFulfilled } from "./reducerUtils";

const initialState = {
    keywordLists: [],

    // filters
    filterRefineSort: "published_date_desc",
    filters: {
        keywordRules: ["selectAll"],
        countries: ["selectAll"],
        platforms: ["selectAll"],
        languages: ["selectAll"],
        duration: "7",
        // endDateTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        // startDateTime: moment(new Date().setFullYear(new Date().getFullYear() - 1)).format("YYYY-MM-DD HH:mm:ss"),
        publications: [],
        entityType: "all",
        entitySubType: "all",
        filterKeyword: "",
        rollingDate: true,
        topics: [],
        subtopics: [],
    },
    filterRefineFilter: {
        sentiment: ["all"],
        sentimentType: "all",
        contentSafety: "sfw",
        contentSafetyType: "all",
        media: "all",
        postType: "all",
        sampling: "100",
        channel: "all",
        exclusion: "yes",
    },
    customQuery: "",
    filterUpdated: 0,
    filterRefineUpdate: 0,
    otherFiltersUpdated: 0,
};

const keywordSyncedPostsReducer = (state = initialState, action) => {
    switch (action.type) {
        case isFulfilled(FETCH_SMR_KEYWORD_LISTS): {
            const smrKeywords = [];

            if (Array.isArray(action.payload)) {
                action.payload?.forEach((obj) => {
                    if (obj.is_deleted !== 1) {
                        smrKeywords.push({
                            ...obj,
                            rule: JSON.parse(obj.rule),
                        });
                    }
                });
            }

            return { ...state, keywordLists: smrKeywords };
        }
        case APPLY_FILTER_SMR_KEYWORD: {
            return {
                ...state,
                filters: action.payload.filters,
                filterRefineFilter: action.payload.filterRefineFilter,
                filterUpdated: state.filterUpdated + 1,
            };
        }

        case RELOAD_PAGE:
            return {
                ...state,
                otherFiltersUpdated: state.otherFiltersUpdated + 1,
            };

        case RESET_CURRENT_SMR_KEYWORD_FILTER: {
            let filters = {
                filterRefineFilter: initialState.filterRefineFilter,
                filters: initialState.filters,
                filterRefineSort: initialState.filterRefineSort,
                filterRefineUpdate: 0,
                filterUpdated: 0,
            };
            return {
                ...state,
                ...filters,
            };
        }
        case UPDATE_FILTER_REFINE_SORT_SMR_KEYWORD:
            return { ...state, filterRefineSort: action.payload, filterRefineUpdate: state.filterRefineUpdate + 1 };

        case UPDATE_CUSTOM_QUERY_SMR_KEYWORD: {
            const { value, applyFilter } = action.payload;
            if (applyFilter) return { ...state, customQuery: value, otherFiltersUpdated: state.otherFiltersUpdated + 1 };
            else return { ...state, customQuery: value };
        }

        default:
            return state;
    }
};
export default keywordSyncedPostsReducer;
